import { AbstractControl, UntypedFormGroup, ValidatorFn } from '@angular/forms';

import { IInputField } from './input';
import { ISaveCancelButtonConfig, SaveCancelButtonConfig } from './button';
import { ISelectField } from './select';
import { ICheckboxField } from './checkbox';
import { IDateRangeField } from './daterange';
import { ITextAreaField } from './textarea';

export interface IFormComponent<T> {
  config: IFormField<T>;
  formConfig: IFormConfig;
  group: UntypedFormGroup;

  formControl: AbstractControl;
}
export interface IHasImage {
  currentImageFile: string;
}

export type FieldType =
  | 'checkbox'
  | 'input'
  | 'password'
  | 'textarea'
  | 'select'
  | 'file'
  | 'daterange';

export interface IFormField<T> {
  name: string;
  label: string;
  placeholder: string;
  icon?: string;
  fieldType: FieldType;
  fieldConfig: T;
  validation?: ValidatorFn[];
  value: string | number | boolean;
  hiddenField?: boolean;
  hiddenValue?: string;
  disabled?: boolean;
  showErrorMessages: boolean;
  required?: boolean;
}

export class FormField<T> implements IFormField<T> {
  name: string;
  label: string;
  placeholder: string = '';
  icon?: string = '';
  fieldType: FieldType;
  fieldConfig: T;
  validation?: ValidatorFn[] = [];
  value: string | number = '';
  hiddenField: boolean = false;
  hiddenValue: string = '';
  disabled?: boolean = false;
  showErrorMessages: boolean = true;

  constructor(configOverride?: Partial<IFormField<T>>) {
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}

export interface IFormConfig {
  formName: string;
  formTitle: string;
  instructionPosition: string;
  instructionText: string;
  validation: ValidatorFn[];
  controls: IFormField<
    | ICheckboxField
    | IInputField
    | ISelectField
    | IDateRangeField
    | ITextAreaField
  >[];
  showIcons: boolean;
  submit?: ISaveCancelButtonConfig;
}

export class FormConfig implements IFormConfig {
  formName: string = 'form';
  formTitle: string = '';
  instructionPosition: string = '';
  instructionText: string = '';
  validation: ValidatorFn[] = [];
  showIcons: boolean = false;
  controls: IFormField<
    | ICheckboxField
    | IInputField
    | ISelectField
    | IDateRangeField
    | ITextAreaField
  >[] = [];
  submit?: ISaveCancelButtonConfig = new SaveCancelButtonConfig();

  constructor(configOverride?: Partial<IFormConfig>) {
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}
